import { render, staticRenderFns } from "./siteLinks.vue?vue&type=template&id=5dd9ffe0&scoped=true&"
import script from "./siteLinks.vue?vue&type=script&lang=js&"
export * from "./siteLinks.vue?vue&type=script&lang=js&"
import style0 from "./siteLinks.vue?vue&type=style&index=0&id=5dd9ffe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd9ffe0",
  null
  
)

export default component.exports